export function parseJwt(token: string | null): Record<string, any> | null {
    if (!token) {
        return null;
    }

    try {
        const [, payloadPart] = token.split('.');
        if (!payloadPart) {
            return null;
        }

        const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
        const normalizedBase64 = `${base64}${'='.repeat((4 - (base64.length % 4)) % 4)}`;
        const decoded = atob(normalizedBase64);
        return JSON.parse(decoded);
    } catch {
        return null;
    }
}

export function isSwitchedUser(accessToken: string | null): boolean {
    const payload = parseJwt(accessToken);
    return Boolean(payload?.is_switched_user);
}
